import { FC, useState, useEffect } from 'react'
import TextTableFilter from '../../common/TextTableFilter'
import { useSearchParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import fileDownload from 'js-file-download';
import * as XLSX from 'xlsx';

import { getTransactionReports } from "../core/_requests";
import SharedData from "../../common/SharedData";
import { prepareFilters } from "../../orders/core/_requests";
import { ITransactionReportModel} from '../core/_models'
import {tenantBrandName} from '../../../tenant/tenantState'

export const TransactionReportFilters: FC = ({}) => {
    const { formatMessage } = useIntl();
    const [searchParams, setSearchParams] = useSearchParams()
    const [startDateFilter, setStartDateFilter] = useState(searchParams.get('filter_date_start') || '')
    const [endDateFilter, setEndDateFilter] = useState(searchParams.get('filter_date_end') || '')
    const [startDueDateFilter, setStartDueDateFilter] = useState(searchParams.get('filter_start_due_date') || '')
    const [endDueDateFilter, setEndDueDateFilter] = useState(searchParams.get('filter_end_due_date') || '')

    const { currentUser, language } = SharedData();

    const handleChange = (id: string, value: string, type: string) => {
        if (value) {
            searchParams.set(id, value)
        } else {
            searchParams.delete(id)
        }
    }

    const clearFilters = (): void => {
        setSearchParams({}, {
            replace: true
        })
        setStartDateFilter('')
        setEndDateFilter('')
        setStartDueDateFilter('')
        setEndDueDateFilter('')
    }

    const filter = (): void => {
        setSearchParams(searchParams, {
            replace: true
        })
    }

    const ExportTransactionReport = async (): Promise<void> => {
        try {
            prepareFilters(searchParams, setSearchParams);
            const queryParams = document.location.search;
            const res = await getTransactionReports(queryParams, currentUser?.token, language);

            const data = res.data.data;
            const responseData: ITransactionReportModel[] = Object.values(data.transaction_products);

            const headers: string[] = Object.keys(responseData[0]).filter(header =>
                header !== 'product_id' && header !== 'is_return' && header !== 'image' && header !== 'color' && header !== 'type_product_id'
            );

            const excelData: (string | number)[][] = responseData.map((product: ITransactionReportModel) =>
                headers.map((header: string) => {
                    const value = product[header as keyof ITransactionReportModel];
                    return typeof value === 'boolean' ? value.toString() : value ?? '-';
                })
            );

            excelData.push([]);
            excelData.push(["Total Sold Products Sale Price ", data.total_transaction?.total_order_payment_sale_price || ""]);
            excelData.push([`${tenantBrandName('en')} Fees`, data.total_transaction?.total_order_payment_dumyah_fees || 0]);
            excelData.push(["Order Net", data.total_transaction?.total_order_payment_net || 0]);

            excelData.push([]);
            excelData.push(["Total Sold Products Sale Price ", data.total_transaction?.total_refund_sale_price || ""]);
            excelData.push([`${tenantBrandName('en')} Return Fees`, data.total_transaction?.total_refund_dumyah_fees || ""]);
            excelData.push(["Return Order Net", data.total_transaction?.total_refund_quantity || 0]);

            excelData.push([]);
            excelData.push([]);
            excelData.push([`${tenantBrandName('en')} Pickup Fees`, data.total_transaction?.total_pickup_fees_dumyah_fees	|| ""]);
            excelData.push(["Pickup Fees Net", data.total_transaction?.total_pickup_fees_net	 || 0]);

            if (Number(data.total_transaction?.total_barcode_printing_net || 0) !== 0) {
                excelData.push([]);
                excelData.push(["Barcode Printing Labels", data.total_transaction?.total_barcode_printing_labels || 0]);
                excelData.push(["Barcode Printing Fees Net", data.total_transaction?.total_barcode_printing_net || 0]);
            }

            excelData.push([]);
            excelData.push([]);
            excelData.push([]);
            excelData.push(["Total Net", data.total_transaction?.final_net || 0]);

            const worksheet = XLSX.utils.aoa_to_sheet([headers, ...excelData]);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Transaction Report');

            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });

            try {
                fileDownload(blob, 'Transaction Report.xlsx');
            } catch (error) {
                console.error('Error during file download:', error);
            }
        } catch (error) {
            console.error('Error preparing export data:', error);
        }
    };


    return (
        <>
            <div className='card-body border-bottom pb-10 mb-5'>
                <div className='row'>
                    <TextTableFilter
                        id='filter_date_start'
                        label={formatMessage({ id: "from" })}
                        value={startDateFilter}
                        setValue={setStartDateFilter}
                        onChange={handleChange}
                        delay={0}
                        type='date'
                    />
                    <TextTableFilter
                        id='filter_date_end'
                        label={formatMessage({ id: "to" })}
                        value={endDateFilter}
                        setValue={setEndDateFilter}
                        onChange={handleChange}
                        delay={0}
                        type='date'
                    />
                    {/*<TextTableFilter*/}
                    {/*    id='filter_start_due_date'*/}
                    {/*    label={formatMessage({id: "due_date_from"})}*/}
                    {/*    value={startDueDateFilter}*/}
                    {/*    setValue={setStartDueDateFilter}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    type='date'*/}
                    {/*/>*/}
                    {/*<TextTableFilter*/}
                    {/*    id='filter_end_due_date'*/}
                    {/*    label={formatMessage({id: "due_date_to"})}*/}
                    {/*    value={endDueDateFilter}*/}
                    {/*    setValue={setEndDueDateFilter}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    type='date'*/}
                    {/*/>*/}
                    <div className='col-sm-12 col-md-2'>
                        <button
                            className='btn btn-light mt-md-10 w-100 fs-6 fw-semibold'
                            onClick={filter}
                        >
                            {formatMessage({ id: "filter" })}
                        </button>
                    </div>
                    <div className='col-sm-12 col-md-2'>
                        <button
                            type='reset'
                            className='btn btn-light mt-md-10 w-100 fs-6 fw-semibold'
                            onClick={clearFilters}
                        >
                            {formatMessage({ id: "reset" })}
                        </button>
                    </div>

                    <div className='col-sm-12 col-md-2'>
                        <button
                            className='btn btn-light mt-md-10 w-100 fs-6 fw-semibold'
                            onClick={ExportTransactionReport}
                        >
                            {formatMessage({ id: "export" })}
                        </button>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TransactionReportFilters
